module.exports = __webpack_public_path__ + "static/media/wire.60bd25be.png";